import './app.css';
import {Header, Home, Footer} from './pages';


export function App() {
  return (
    <div>
      <Header />
      <Home />
      <Footer />
    </div>
  );
}


